import React from 'react';
import { getISODay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import _get from 'lodash/get';
import { hourLabelsMap } from './CurrentlyOpenLabel.constants';
import { getAllHourStatus } from './CurrentlyOpenLabel.utils';
import { EnhancedLabelsPropType } from './HoursOfOperation.PropTypes';
import { HourOfOperationPropType } from '../../services/proptypes';
import { isServerSideRendering } from '../../utils/gatsby';
var defaultProps = {
  timezone: null,
  enhancedLabels: {}
};

/**
 * Returns null if it's not today or no timezone is set, else Open or Closed.
 * Inspired on https://stackoverflow.com/a/59492313
 *
 * Assumes all hours[i].day are the same
 */
export default function CurrentlyOpenLabel(_ref) {
  var hours = _ref.hours,
    timezone = _ref.timezone,
    enhancedLabels = _ref.enhancedLabels;
  if (isServerSideRendering()) {
    return null;
  }
  // Can't be totally sure without a timezone,
  // so don't do this if we don't have one.
  if (!timezone || timezone === 'UTC' || hours.length === 0) {
    return null;
  }

  // If weekday isn't today.
  var now = utcToZonedTime(new Date(), timezone);
  var weekDayIso = getISODay(now);
  if (weekDayIso !== hours[0].day) {
    return null;
  }
  var allHourStatus = getAllHourStatus(hours, now, timezone);
  return hourLabelsMap.reduce(function (previousValue, _ref2) {
    var hourStatus = _ref2.hourStatus,
      defaultLabel = _ref2.defaultLabel,
      alternateLabelKey = _ref2.alternateLabelKey,
      className = _ref2.className;
    if (allHourStatus.includes(hourStatus)) {
      var label = _get(enhancedLabels, alternateLabelKey, defaultLabel);
      return /*#__PURE__*/React.createElement("span", {
        className: className,
        style: {
          fontWeight: 'bold'
        }
      }, label);
    }
    return previousValue;
  }, null);
}
CurrentlyOpenLabel.defaultProps = defaultProps;